import classNames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import styles from "./product-fitment.module.scss";

interface IProps {
  iconSize?: string;
  className?: string;
}
function ProductFitmentUniversal(props: IProps) {
  const { iconSize = "big", className = "" } = props;
  const { t } = useTranslation("product");

  return (
    <div className={classNames(styles.product_fitment_container, styles.success_container, className)}>
      <div className={`d-flex ${styles.icon_description_container}`}>
        <div className={classNames({
          [styles.fitment_icon]: true,
          [styles.success_icon]: iconSize === "big",
          [styles.small_success_icon]: iconSize === "small",
          [styles.big_icon]: (iconSize === "big"),
          [styles.small_icon]: iconSize === "small",
        })}
        >
          <i className="fa fa-check" />
        </div>
        <div className="flex-grow-1">
          <PAText
            component="span"
            bold
            fontSize={FONT_SIZE[2]}
            className={styles.success_heading}
          >
            {t("Universal Fit")}
          </PAText>
          <PAText
            component="span"
            fontSize={FONT_SIZE[2]}
            bold
            className={styles.success_heading}
          >
            {t("This product fits all vehicles")}
          </PAText>

        </div>
      </div>
    </div>
  );
}

export default ProductFitmentUniversal;
